import { Phone } from "lucide-react";
import { telLink, waLink } from "@/lib/api";
import { WhatsAppIcon } from "./icons";

export const FloatingButtons = ({ s }) => (
  <div className="fixed z-50 right-4 bottom-4 sm:right-6 sm:bottom-6 flex flex-col items-end gap-3" data-testid="floating-buttons">
    <a
      href={telLink(s.phone_number)}
      aria-label={`Ligar para o hotel: ${s.phone_display}`}
      data-testid="floating-call-button"
      className="h-12 w-12 rounded-full bg-[#141418]/90 backdrop-blur border border-white/15 text-[#CBD5E1] flex items-center justify-center hover:border-[#C5A059] hover:text-white transition-colors duration-300 shadow-xl"
    >
      <Phone className="w-5 h-5" strokeWidth={1.5} />
    </a>
    <a
      href={waLink(s.whatsapp_number, s.wa_msg_default)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Conversar pelo WhatsApp"
      data-testid="floating-whatsapp-button"
      className="group h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_40px_-10px_rgba(37,211,102,0.6)] hover:bg-[#20BA5A] transition-[background-color,transform] duration-300 hover:scale-105"
    >
      <WhatsAppIcon className="w-7 h-7" />
    </a>
  </div>
);
